export default __webpack_public_path__ + "static/media/aUiLF46OidegowLIPW1d7erIc7R2.aa626f7e.jpg";